import { moderationDashModuleQuery, useModule } from 'system/structure-modules';

export default function ModerationDashboardReviewScreen() {
    const { PremodReviewScreen } = useModule(moderationDashModuleQuery);
    return <PremodReviewScreen />;
}
